import { PlanTab } from '@/pages/CarePlanView/PlanTab';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { patientId } = Route.useParams();
  return <PlanTab patientId={patientId} />;
};

export const Route = createFileRoute('/_auth/care-plan/$patientId/plan')({
  component: RouteComponent,
});
